module.exports = __webpack_public_path__ + "static/media/sirine.06aca364.webp";